<template>
    <div>
        <b-button v-b-modal.modal-1 variant="outline-dark" class="mt-1">Join Our Team</b-button>

        <b-modal id="modal-1" ref="modal-1" title="Contact Us" hide-footer>
            <b-form @submit.prevent="onSubmit">

                <b-form-group label="Name" label-cols="3" required
                              breakpoint="md" horizontal>
                    <b-input v-model="applicantName"></b-input>
                </b-form-group>

                <b-form-group label="Email" label-cols="3" type="email" required
                              breakpoint="md" horizontal>
                    <b-input v-model="applicantEmail"></b-input>
                </b-form-group>

                <b-form-group label="Phone" label-cols="3" type="phone" required
                              breakpoint="md" horizontal>
                    <b-input v-model="applicantPhone"></b-input>
                </b-form-group>

                <b-button type="submit">
                    Submit
                </b-button>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: "JoinOurTeamModal",
    data() {
        return {
            applicantName: '',
            applicantEmail: '',
            applicantPhone: '',
        }
    },
    methods: {
        onSubmit(e) {
            e.preventDefault();
            let _self = this;
            _self.isLoading = true;
            let data = {
                name: _self.applicantName,
                email: _self.applicantEmail,
                phone: _self.applicantPhone,
            };
            axios.post('/api/join-our-team', data)
                .then(function () {
                    _self.isLoading = false;
                    _self.applicantName = '';
                    _self.applicantEmail = '';
                    _self.applicantPhone = '';
                    _self.$refs['modal-1'].hide();
                    alert('Thank you! Your inquiry has been sent.');
                }).catch(function () {
                    _self.isLoading = false;
                    alert('Sorry, we could not send your message. Please try again later.');
                });
        },
    },
}
</script>

<style scoped>

</style>
